import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/functions';
import { toDateFormat } from 'utils/helpers/timestampHelper';
import {
  PROGRESS_IMAGES, GRAPHS, FOOD, WATER, EXERCISE, BLOOD_PRESSURE, STEPS, DIGESTION, CRAVING,
  HUNGER, ENERGY, SLEEP, WEIGHT, HEART_RATE, ADHERENCE, TRACK
} from 'utils/constants/collectionNames';
import { subCollectionsNames } from 'utils/constants/graphs';
import { CLIENT_PROGRESS_IMAGES } from 'utils/constants/storageFolders';
import { ulid } from 'ulid';
import {
  GET_CLIENT_PROGRESS_IMAGES_ERROR,
  GET_CLIENT_PROGRESS_IMAGES_SUCCESS,
  GET_CLIENT_PROGRESS_IMAGES_APPEND_SUCCESS,
  GET_CLIENT_PROGRESS_IMAGES_SUMMARY_SUCCESS,
  GET_GRAPHS_DATA_SUCCEED,
  GET_GRAPHS_DATA_ERROR,
  GET_CLIENT_TRACK_SUCCEED,
  GET_CLIENT_TRACK_ERROR,
  RESET_GRAPHS_LOADING_STATE,
  EDIT_CLIENT_TRACK_SUCCEED,
  EDIT_CLIENT_TRACK_ERROR,
  LOADING_CLIENT_TRACK_STATE
} from './Types';

export const PROGRESS_IMAGES_LIMIT = 10;

export const getClientProgressPhotosFirst = clientId => async dispatch => {
  const firestore = firebase.firestore();
  const queryRef = firestore
    .collection(PROGRESS_IMAGES)
    .where('client_id', '==', clientId)
    .where('trainer_id', '==', firebase.auth().currentUser.uid)
    .limit(PROGRESS_IMAGES_LIMIT)
    .orderBy('created_at', 'desc');

  queryRef
    .get()
    .then(snapshot => {
      if (snapshot.empty) {
        dispatch({
          type: GET_CLIENT_PROGRESS_IMAGES_SUCCESS,
          payload: { images: [], last: null }
        });
        return;
      }
      let images = [];
      let lastImage;
      snapshot.forEach(doc => {
        lastImage = doc;
        images.push(doc.data());
      });

      dispatch({
        type: GET_CLIENT_PROGRESS_IMAGES_SUCCESS,
        payload: { images, last: lastImage }
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_CLIENT_PROGRESS_IMAGES_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const getClientProgressPhotos = (
  clientId,
  lastDoc
) => async dispatch => {
  const firestore = firebase.firestore();
  const queryRef = firestore
    .collection(PROGRESS_IMAGES)
    .where('client_id', '==', clientId)
    .where('trainer_id', '==', firebase.auth().currentUser.uid)
    .limit(PROGRESS_IMAGES_LIMIT)
    .orderBy('created_at', 'desc')
    .startAfter(lastDoc);

  queryRef
    .get()
    .then(snapshot => {
      if (snapshot.empty) {
        dispatch({
          type: GET_CLIENT_PROGRESS_IMAGES_APPEND_SUCCESS,
          payload: { images: [], last: null }
        });
        return;
      }
      let images = [];
      let lastImage;
      snapshot.forEach(doc => {
        lastImage = doc;
        images.push(doc.data());
      });

      if (images.length !== PROGRESS_IMAGES_LIMIT) lastImage = null;
      console.log(lastImage);
      dispatch({
        type: GET_CLIENT_PROGRESS_IMAGES_APPEND_SUCCESS,
        payload: { images, last: lastImage }
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_CLIENT_PROGRESS_IMAGES_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const getClientProgressPhotosSummary = clientId => async dispatch => {
  const firestore = firebase.firestore();
  const queryRefLast = firestore
    .collection(PROGRESS_IMAGES)
    .where('client_id', '==', clientId)
    .where('trainer_id', '==', firebase.auth().currentUser.uid)
    .limit(1)
    .orderBy('created_at', 'desc');

  const queryRefFirst = firestore
    .collection(PROGRESS_IMAGES)
    .where('client_id', '==', clientId)
    .where('trainer_id', '==', firebase.auth().currentUser.uid)
    .limit(1)
    .orderBy('created_at');

  const promises = [];
  promises.push(getPhoto(queryRefFirst));
  promises.push(getPhoto(queryRefLast));

  const images = await Promise.all(promises);

  dispatch({
    type: GET_CLIENT_PROGRESS_IMAGES_SUMMARY_SUCCESS,
    payload: images
  });

  async function getPhoto(queryRef) {
    return queryRef
      .get()
      .then(snapshot => {
        if (snapshot.empty) {
          return;
        }
        let image = '';
        snapshot.forEach(doc => {
          image = doc.data();
        });
        return image;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};

export const addClientProgressPhotos = (clientId, photos) => async dispatch => {
  console.log(photos);
  const front = await getDownloadURL(photos.front, CLIENT_PROGRESS_IMAGES);
  const back = await getDownloadURL(photos.back, CLIENT_PROGRESS_IMAGES);
  const side = await getDownloadURL(photos.side, CLIENT_PROGRESS_IMAGES);

  const progressImage = {
    images: {
      front,
      back,
      side
    },
    trainer_id: firebase.auth().currentUser.uid,
    client_id: clientId,
    created_at: new Date()
  };

  const firestore = firebase.firestore();
  var docRef = firestore.collection(PROGRESS_IMAGES).doc();
  return docRef.set({ ...progressImage }).catch(function(error) {
    console.log(error);
  });

  async function getDownloadURL(file, path) {
    const ref = firebase.storage().ref();
    const snapshot = await ref.child(`${path}/${ulid()}`).put(file);

    return snapshot.ref.getDownloadURL();
  }
};

export const getGraphsData = clientId => async dispatch => {
  dispatch({
    type: RESET_GRAPHS_LOADING_STATE,
  });
  subCollectionsNames.forEach(subCollectionName => {
    getDataFirebaseCall(clientId, subCollectionName, dispatch)
  });
};

const getDataFirebaseCall = (clientId, subCollectionName, dispatch) => {

  const firestore = firebase.firestore();
  firestore
    .collection(GRAPHS)
    .doc(clientId)
    .collection(subCollectionName)
    .orderBy('date')
    .get()
    .then(querySnapshot => {
      let data = {}
      switch (subCollectionName) {
        case FOOD:
          data = prepareFoodData(querySnapshot); break;
        case WATER:
          data = prepareWaterData(querySnapshot); break;
        case EXERCISE:
          data = prepareExercise(querySnapshot); break;
        case BLOOD_PRESSURE:
          data = prepareBloodPressure(querySnapshot);break;
        case STEPS:
          data = prepareSteps(querySnapshot);break;
        case DIGESTION:
          data = prepareDigestion(querySnapshot);break;
        case CRAVING:
          data = prepareCraving(querySnapshot);break;
        case HUNGER:
          data = prepareHunger(querySnapshot);break;
        case ENERGY:
          data = prepareEnergy(querySnapshot);break;
        case SLEEP:
          data = prepareSleep(querySnapshot);break;
        case WEIGHT:
          data = prepareWeight(querySnapshot);break;
        case HEART_RATE:
          data = prepareHeartRate(querySnapshot);break;
        case ADHERENCE:
          data = prepareAdherence(querySnapshot);break;
        default:
          data = {};
      }
      dispatch({
        type: GET_GRAPHS_DATA_SUCCEED,
        payload: { ...data }
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_GRAPHS_DATA_ERROR,
        payload: `error: ${error}`
      });
    });
};

const prepareFoodData = querySnapshot => {
  let foodData = {calories: [], carbs: [], fats: [], proteins: []}
  querySnapshot.docs &&
    querySnapshot.docs.forEach(food => {
      let date = toDateFormat(food.data().date);

      foodData.calories.push([date, ~~food.data().total_calories]);
      foodData.carbs.push([date, ~~food.data().total_carbs]);
      foodData.fats.push([date, ~~food.data().total_fat]);
      foodData.proteins.push([date, ~~food.data().total_protein]);
    });
  return foodData;
}

const prepareWaterData = querySnapshot => {
  let water = [];
  querySnapshot.docs &&
    querySnapshot.docs.forEach(waterEle => {
      water.push([toDateFormat(waterEle.data().date), ~~waterEle.data().liters]);
    });
  return {water: [...water]};
}

const prepareExercise = querySnapshot => {
  let exercises = [];
  querySnapshot.docs &&
    querySnapshot.docs.forEach(exercise => {
      exercises.push([toDateFormat(exercise.data().date), ~~exercise.data().duration]);
    });
  return {exercises: [...exercises]};
}

const prepareBloodPressure =querySnapshot => {
  let bloodPressure = [];
  querySnapshot.docs &&
    querySnapshot.docs.forEach(exercise => {
      bloodPressure.push([
        toDateFormat(exercise.data().date),
        ~~exercise.data().diastolic_blood_pressure,
        ~~exercise.data().systolic_blood_pressure
      ]);
    });
  return {bloodPressure: [...bloodPressure]};
}

const prepareSteps = querySnapshot => {
  let steps = [];
  querySnapshot.docs &&
    querySnapshot.docs.forEach(stepsEle => {
      steps.push([toDateFormat(stepsEle.data().date), ~~stepsEle.data().steps]);
    });
  return {steps: [...steps]};
}

const prepareDigestion = querySnapshot => {
  let digestion = [];
  querySnapshot.docs &&
    querySnapshot.docs.forEach(element => {
      digestion.push([toDateFormat(element.data().date), ~~element.data().rating]);
    });
  return {digestion: [...digestion]};
}

const prepareCraving = querySnapshot => {
  let craving = [];
  querySnapshot.docs &&
    querySnapshot.docs.forEach(element => {
      craving.push([toDateFormat(element.data().date), ~~element.data().rating]);
    });
  return {craving: [...craving]};
}

const prepareHunger = querySnapshot => {
  let hunger = [];
  querySnapshot.docs &&
    querySnapshot.docs.forEach(element => {
      hunger.push([toDateFormat(element.data().date), ~~element.data().rating]);
    });
  return {hunger: [...hunger]};
}

const prepareEnergy = querySnapshot => {
  let energy = [];
  querySnapshot.docs &&
    querySnapshot.docs.forEach(element => {
      energy.push([toDateFormat(element.data().date), ~~element.data().rating]);
    });
  return {energy: [...energy]};
}

const prepareSleep = querySnapshot => {
  let sleep = [];
  querySnapshot.docs &&
    querySnapshot.docs.forEach(element => {
      sleep.push([toDateFormat(element.data().date), ~~element.data().rating]);
    });
  return {sleep: [...sleep]};
}

const prepareWeight = querySnapshot => {
  let weight = [];
  querySnapshot.docs &&
    querySnapshot.docs.forEach(element => {
      weight.push([toDateFormat(element.data().date), ~~element.data().weight]);
    });
  return {weight: [...weight]};
}

const prepareHeartRate = querySnapshot => {
  let heartRate = [];
  querySnapshot.docs &&
    querySnapshot.docs.forEach(element => {
      heartRate.push([toDateFormat(element.data().date), ~~element.data().heart_rate]);
    });
  return {heartRate: [...heartRate]};
}

const prepareAdherence = querySnapshot => {
  let adherence = [];
  querySnapshot.docs &&
    querySnapshot.docs.forEach(element => {
      adherence.push([toDateFormat(element.data().date), ~~element.data().adherence]);
    });
  return {adherence: [...adherence]};
}

export const getClientTrack = clientId => async dispatch => {
  dispatch({
    type: LOADING_CLIENT_TRACK_STATE,
  });
  let firestore = firebase.firestore();
  let docRef = firestore.collection(TRACK).doc(clientId);
  docRef
    .get()
    .then(function(doc) {
      let track = doc.exists ? { ...doc.data() } : {};
      dispatch({
        type: GET_CLIENT_TRACK_SUCCEED,
        payload: track
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_CLIENT_TRACK_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const updateClientTrack = (clientId, value) => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(TRACK).doc(clientId);

  return docRef
    .set({ ...value }, { merge: true })
    .then(function() {
      return dispatch({
        type: EDIT_CLIENT_TRACK_SUCCEED
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: EDIT_CLIENT_TRACK_ERROR,
        payload: `error: ${error}`
      });
    });
}
